import { ReportSimulation } from 'domain/entity/reportSimulation';
import { CreateOrPreviewAutomationCriteria } from 'use-case/automation/create/createAutomationCriteria';
import getGenericUseCase from 'use-case/genericUseCase';

const getSimulateReportsUseCase = getGenericUseCase<ReportSimulation[], CreateOrPreviewAutomationCriteria>((client, criteria) =>
    client(criteria)
);

export default getSimulateReportsUseCase;
